module.exports = __webpack_public_path__ + "img/success_footer_text1.35bc352e.png";